export const styles = {
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: 1,
  },
  dialogContent: { p: 0, minHeight: 250 },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
  mainBox: { display: 'flex', flexDirection: 'column', height: '100%' },
  emptyBox: { p: 3, textAlign: 'center' },
  emptyButton: { mt: 1 },
  list: { pt: 0 },
  listItem: { borderBottom: '1px solid #f0f0f0' },
  shoppingBasketIcon: { color: 'primary.main', opacity: 0.8 },
  createNewListItem: { color: 'primary.main', py: 2 },
  addIcon: { mr: 2, ml: 1 },
  createNewBox: { p: 2 },
  textField: { mb: 2 },
  actionsBox: { display: 'flex', gap: 1, justifyContent: 'flex-end' },
  dialogActions: { p: 2 },
};
